import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox, Dropdown, Select, Table } from "semantic-ui-react";
import {
    SetCBCountry,
    SetCBDirection,
    ToggleCBBranches,
} from "../../../../../../actions/cbBranchesActions";
import { countryOptions, directionOptions } from "../../../../../../models/nec";
import { AppState } from "../../../../../../store/configureStore";
import { Loading } from "../../../../../Loading/Loading";
import { extractLinesCB, IOption } from "../../../zipLinesHelper";

export const NECSelectorCB = () => {
    const dispatch = useDispatch();
    const zipFile = useSelector((state: AppState) => state.files.zipFile);
    const { cbBranches, country, direction } = useSelector((state: AppState) => state.cbBranches);
    const [loading, setLoading] = useState(false);
    const [branches, setBranches] = useState<IOption[]>([]);
    const [filteredBranches, setFilteredBranches] = useState<IOption[]>([]);
    const [neFilters, setNeFilters] = useState<IOption[]>([]);
    const [cFilters, setCFilters] = useState<IOption[]>([]);
    const [selectedNeFilter, setSelectedNeFilter] = useState("");
    const [selectedCFilter, setSelectedCFilter] = useState("");
    const activeTimestamps = useSelector((state: AppState) => state.timestamps.timestamps);

    useEffect(() => {
        if (zipFile && country) {
            setLoading(true);
            //extractLinesCB(zipFile, country).then(res => {
            extractLinesCB(zipFile, activeTimestamps, country).then(res => {
                setBranches([...res.branches]);
                setFilteredBranches([...res.branches]);
                setNeFilters([...res.neFilters]);
                setCFilters([...res.cFilters]);
                setLoading(false);
            });
        }
    }, [zipFile, country, activeTimestamps]);

    useEffect(() => {
        if (selectedNeFilter.length > 0 || selectedCFilter.length > 0) {
            let filtered = branches;
            if (selectedNeFilter.length > 0)
                filtered = filtered.filter(x => x.text.includes(selectedNeFilter));
            if (selectedCFilter.length > 0)
                filtered = filtered.filter(x => x.text.includes(selectedCFilter));
            setFilteredBranches(filtered);
        } else setFilteredBranches(branches);
    }, [selectedNeFilter, selectedCFilter, branches]);

    return (
        <div id="necs-selector-container-div-a" className="necs-selector-container transition-container">
            <div id="selectors-lvl-1-div-a" className="selectors-lvl-1">
                <div id="necs-selector-wrapper-a" className="necs-selector-wrapper">
                    <p id="p-NECSelectorCb-country">Country</p>
                    <Select
                        id="select-NECSelectorCb-a"
                        search
                        selectOnBlur={false}
                        upward={false}
                        className="country-select"
                        options={countryOptions}
                        onChange={(e, data: any) => dispatch(SetCBCountry(data.value))}
                        value={country}
                    />
                </div>
                <div id="necs-selector-wrapper-b" className="necs-selector-wrapper">
                    <p id="p-NECSelectorCb-direction">Direction</p>
                    <Select
                        id="select-NECSelectorCb-b"
                        selectOnBlur={false}
                        upward={false}
                        className="direction-select"
                        options={directionOptions}
                        onChange={(e, data: any) => dispatch(SetCBDirection(data.value))}
                        value={direction}
                        disabled
                    />
                </div>
                <div id="necs-selector-wrapper-c" className="necs-selector-wrapper ">
                    <p id="p-NECSelectorCb-NEfilter">NE filter</p>
                    <Dropdown
                        id="dropdown-NECSelectorCb-c"
                        className="filter-dropdown"
                        selectOnBlur={false}
                        upward={false}
                        clearable
                        options={neFilters}
                        selection
                        search
                        onChange={(e, data: any) => setSelectedNeFilter(data.value)}
                        disabled={branches.length === 0}
                    />
                </div>
                <div id="necs-selector-wrapper-d" className="necs-selector-wrapper">
                    <p id="p-NECSelectorCb-Cfilter">C filter</p>
                    <Dropdown
                        id="dropdown-NECSelectorCb-d"
                        className="filter-dropdown"
                        selectOnBlur={false}
                        upward={false}
                        clearable
                        options={cFilters}
                        selection
                        search
                        onChange={(e, data: any) => setSelectedCFilter(data.value)}
                        disabled={branches.length === 0}
                    />
                </div>
            </div>
            {loading ? (
                <Loading />
            ) : country && zipFile ? (
                <div id="neselector-container-loading-a" className="neselector-container">
                    <Table id="table-NECSelector-a" celled compact>
                        <Table.Header id="tableHeader-NECSelector-a">
                            <Table.Row id="tableRow-NECSelector-a">
                                <Table.HeaderCell id="tableHeaderCell-NECSelector-branch">Branch</Table.HeaderCell>
                                <Table.HeaderCell id="tableHeaderCell-NECSelector-select" collapsing>Select</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body id="tableBody-NECSelector-a">
                            {filteredBranches.map((b, index) => (
                                <Table.Row id={`tableRow-NECSelector-map-${index}`} key={b.value}>
                                    <Table.Cell id={`tableCell-NECSelector-map-${index}`}>{b.text}</Table.Cell>
                                    <Table.Cell id={`tableCell-NECSelector-map-a-${index}`}collapsing>
                                        <Checkbox
                                            id={`checkbox-NECSelector-map-${index}`}
                                            slider
                                            checked={cbBranches.some(x => x.id === b.value)}
                                            onClick={() =>
                                                dispatch(
                                                    ToggleCBBranches({
                                                        id: b.value,
                                                        text: b.text,
                                                    })
                                                )
                                            }
                                        />
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </div>
            ) : !zipFile ? (
                <p id="p-NECSelectorCB-pleaseUploadFile">Please upload a file</p>
            ) : !country ? (
                <p id="p-NECSelectorCB-pleaseSelectCountry">Please select country</p>
            ) : null}
        </div>
    );
};
